var Component = require("!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./modal-route-vp"),
  /* template */
  require("!!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-37acf04a!../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./modal-route-vp.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/aggregate/modal/modal-route-vp.vue
// module id = 1899
// module chunks = 1